function socialMediaNonConformityDialog () {
  return {
    restrict: 'E',
    templateUrl: '/audit/dialogs/social-media/non-conformity/non-conformity.html?$$REVISION$$'
  }
}

export { socialMediaNonConformityDialog }
